module.exports = __webpack_public_path__ + "static/media/bicycle_3_wheel.0aa66400.png";